import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import { DESK_NAME } from 'api/sectorAlignmentApi';
import type { JiraFix } from 'api/sectorAlignmentApi';
import { JIRA_GRID, list, type Tagged } from './rows';
import TicketKeyLink from './TicketKeyLink';

const JiraRow = ({ fix }: { fix: Tagged<JiraFix> }) => {
  const { t } = useTranslation();
  const tickets = list(fix.tickets);
  const key = tickets[0]?.key;
  const noStore = fix.reason === 'no-store';

  return (
    <div role="row" className={cn(JIRA_GRID, 'h-[52px] border-b last:border-b-0')}>
      <span role="cell" className="min-w-0 truncate">
        {noStore && key ? (
          <TicketKeyLink issueKey={key} />
        ) : (
          <span className="text-[13.5px] font-medium" title={fix.store ?? undefined}>{fix.store || '—'}</span>
        )}
      </span>
      <span role="cell" className="text-[13px] text-muted-foreground">{DESK_NAME[fix.sd]}</span>
      <span role="cell" className="truncate text-[13px]">
        {noStore
          ? t('Ticket without a store')
          : t('Store without a sector in Jira Assets: its {{count}} tickets are visible to no ECM', { count: tickets.length })}
      </span>
    </div>
  );
};

export default JiraRow;
